/**
 * Organizations Module API Service
 *
 * CRUD operations for organization management (Super Admin only).
 * Base endpoint: /organizations
 */

import api from '@/core/api'
import type {
    Organization,
    CreateOrganizationDto,
    UpdateOrganizationDto,
    OrganizationItemResponse,
    OrganizationListResponse,
} from './types'

/**
 * Get all organizations
 */
export async function getOrganizations(): Promise<Organization[]> {
    const response = await api.get<OrganizationListResponse>('/organizations')
    return response.data.data || []
}

/**
 * Get a single organization by ID
 */
export async function getOrganization(organizationId: string): Promise<Organization | null> {
    const response = await api.get<OrganizationItemResponse>(`/organizations/${organizationId}`)
    return response.data.data || null
}

/**
 * Create a new organization
 */
export async function createOrganization(data: CreateOrganizationDto): Promise<Organization | null> {
    const response = await api.post<OrganizationItemResponse>('/organizations', data)
    return response.data.data || null
}

/**
 * Update an existing organization
 */
export async function updateOrganization(organizationId: string, data: UpdateOrganizationDto): Promise<Organization | null> {
    const response = await api.patch<OrganizationItemResponse>(`/organizations/${organizationId}`, data)
    return response.data.data || null
}

/**
 * Soft-delete an organization
 */
export async function deleteOrganization(organizationId: string): Promise<void> {
    await api.delete(`/organizations/${organizationId}`)
}

export default {
    getOrganizations,
    getOrganization,
    createOrganization,
    updateOrganization,
    deleteOrganization,
}
